import * as types from '../../mutationTypes';

export default {
  [types.SET_FEATURES](state, value) {
    state.features = value;
  }
};
